export { default } from './WinnersSection';
